// extracted by mini-css-extract-plugin
export default {"AccountMainPanel":"AccountMainPanel_AccountMainPanel__RDgba","buttonsPanel":"AccountMainPanel_buttonsPanel__Y5wW0"};